import React from 'react';
import {
  Stack, Switch, Tooltip, Typography,
} from '@mui/material';


const FlowsBillableSwitch = ({ isBillable, onToggle }) => (
  <Tooltip
    title={`Mark this flow as ${isBillable ? 'non-billable' : 'billable'}`}
    placement='bottom'
  >
    <Stack direction='row' gap={1} alignItems='center'>
      <Typography variant='body2' sx={{ fontSize: '0.875rem' }}>
        Billable
      </Typography>
      <Switch
        checked={isBillable}
        onChange={onToggle}
        size='small'
        inputProps={{ 'aria-label': 'Billable Switch' }}
        sx={{ margin: 0 }}
      />
    </Stack>
  </Tooltip>
);

export default FlowsBillableSwitch;
